import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-data-share-qr-dialog',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, NgIf],
    template: `
        <h2 mat-dialog-title>QR-Code scannen</h2>
        <div mat-dialog-content>
            <video #video autoplay muted playsinline style="width:100%;max-height:320px;background:#000"></video>
            <p *ngIf="errorMessage">{{ errorMessage }}</p>
        </div>
        <div mat-dialog-actions align="end">
            <button mat-button (click)="close()">Abbrechen</button>
        </div>
    `
})
export class AppDataShareQrDialogComponent implements OnInit, OnDestroy {
    errorMessage = '';

    private stream?: MediaStream;
    private timer?: number;

    constructor(private readonly dialogRef: MatDialogRef<AppDataShareQrDialogComponent>) {}

    ngOnInit(): void {
        void this.startScanner();
    }

    ngOnDestroy(): void {
        if (this.timer) {
            window.clearInterval(this.timer);
        }
        this.stream?.getTracks().forEach(track => track.stop());
    }

    close(): void {
        this.dialogRef.close();
    }

    private async startScanner(): Promise<void> {
        const video = document.querySelector('app-data-share-qr-dialog video') as HTMLVideoElement | null;

        if (!video) {
            this.errorMessage = 'Kamera-Vorschau nicht verfügbar.';
            return;
        }

        try {
            this.stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
            video.srcObject = this.stream;
            await video.play();
        } catch {
            this.errorMessage = 'Kamera konnte nicht geöffnet werden.';
            return;
        }

        const Detector = (window as any).BarcodeDetector;

        if (!Detector) {
            this.errorMessage = 'QR-Scan im Browser nicht verfügbar – bitte Code-Eingabe nutzen.';
            return;
        }

        const detector = new Detector({ formats: ['qr_code'] });

        this.timer = window.setInterval(async () => {
            try {
                const codes = await detector.detect(video);
                const match = codes.find((code: { rawValue?: string }) => code.rawValue?.trim());

                if (match?.rawValue) {
                    this.dialogRef.close(match.rawValue.trim());
                }
            } catch {
                // ignore scan noise
            }
        }, 700);
    }
}
